<ng-container
  *ngIf="
    !codeValidationAlreadyValidated;
    then resetCodeValidation;
    else goToConnexion
  "
>
</ng-container>

<ng-template #resetCodeValidation>
  <p-wrapper
    id="reset-codeValidation"
    titleWrapper="Le délai de validation de votre compte a expiré"
    *ngIf="!showSuccessReset"
  >
    <div body class="px-5">
      <div class="d-flex justify-content-center">
        <p>
          Vous n'avez pas validé votre inscription dans les 48h suivant la
          réception du mail.
        </p>
      </div>
      <div class="d-flex justify-content-center">
        <p>
          Vous pouvez encore valider votre inscription en renouvelant la demande
          de validation !
        </p>
      </div>
      <div class="d-flex justify-content-center">
        <p-button
          id="btn-reset-codeValidation"
          label="Renouveler ma demande"
          [width]="100"
          class="col-6"
          (click)="onResetCodeValidation()"
        ></p-button>
      </div>
    </div>
  </p-wrapper>

  <app-success
    *ngIf="showSuccessReset"
    [message]="
      'Un nouveau mail vous a été envoyé vous permettant de finaliser la création de votre compte, vous pouvez fermer cette fenêtre.'
    "
  ></app-success>
</ng-template>

<ng-template #goToConnexion>
  <p-wrapper
    id="accountAlreadyValidated"
    titleWrapper="Vous avez déjà validé votre compte"
  >
    <div body class="px-5">
      <div class="d-flex justify-content-center">
        <p>
          Vous avez déjà validé votre compte suite à votre demande de création
          de compte.
        </p>
      </div>
      <div class="d-flex justify-content-center">
        <p>
          Vous pouvez dès à présent vous connecter à celui-ci grâce à la page de
          connexion Perval !
        </p>
      </div>
      <div class="d-flex justify-content-center">
        <p-button
          id="btn-go-to-connexion"
          label="Connectez-vous"
          [width]="100"
          class="col-6"
          (click)="backToConnexion()"
        ></p-button>
      </div>
    </div>
  </p-wrapper>
</ng-template>
